export default "__VITE_ASSET__6cc2841b__$_?nuxt_component=async__"